import { render, staticRenderFns } from "./CourseSummary.vue?vue&type=template&id=2885db04"
import script from "./CourseSummary.vue?vue&type=script&lang=js"
export * from "./CourseSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports